import { IBrmApiError } from "types";

export const isBrmApiError = (err: any): err is IBrmApiError => {
  return err && "status" in err && "body" in err && "response" in err && "statusText" in err;
};

export const isError = (err: unknown): err is Error => err instanceof Error;
